import React, { Component } from 'react';
import { Form } from 'antd';

const FormItem = Form.Item;

export default class PropertyItem extends Component {

    state = {

    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        this.registerPropertyValueChangedEvent(this.props.source);
    }

    componentWillReceiveProps(nextProps) {
        this.unregisterPropertyValueChangedEvent();
        this.registerPropertyValueChangedEvent(nextProps.source);
    }

    componentWillUnmount() {
        this.unregisterPropertyValueChangedEvent();
    }

    registerPropertyValueChangedEvent(property) {
        this.unregisterPropertyChangedListener = property.registerPropertyChangedListener((name, valOld, valNew, subName) => {
            // console.log(`onPropertyValueChanged from PropertyItem: ${property.name}, ${name}`);
            this.onPropertyValueChanged(property.name, valOld, valNew, name);
        });
    }

    unregisterPropertyValueChangedEvent() {
        if (this.unregisterPropertyChangedListener)
            this.unregisterPropertyChangedListener();
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        if (subName === "visible")
            this.setState({});
    }

    render() {

        return (
            <FormItem {...this.props} labelAlign="left" style={{ display: (this.props.source.visible === false ? 'none' : (this.props.source.formItemLayout ? "block" : "")) }}>
                {this.props.children}
            </FormItem>
        );
    }
}
